// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"dk","summaryPar":"ek","ratingCategories":"fk","reviewerInfo":"gk","reviewTypes":"hk","expanded":"ik"};